export const EMAIL_VERIFICATION_DOMAINS_ERROR = 'Enter valid email domains, e.g. luxuryescapes.com';

const EMAIL_VERIFICATION_DOMAINS_HELPER_TEXT =
  'Comma-separated email domains. Customers must have a verified email at one of these domains; leave empty for unrestricted. This can be updated after claims have been made.';

function isValidEmailDomain(domain: string): boolean {
  if (domain.length > 253) {
    return false;
  }

  const labels = domain.split('.');
  return labels.length > 1 && labels.every((label) => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label));
}

export function getEmailVerificationDomainsPayload(input: string): Array<string> {
  const normalizedDomains = input
    .split(',')
    .map((domain) => domain.trim().replace(/^@/, '').toLowerCase())
    .filter(Boolean);

  if (normalizedDomains.some((domain) => !isValidEmailDomain(domain))) {
    throw new Error(EMAIL_VERIFICATION_DOMAINS_ERROR);
  }

  return [...new Set(normalizedDomains)];
}

export function formatEmailVerificationDomains(domains?: Array<string>): string {
  return domains?.join(', ') ?? '';
}

export function validateEmailVerificationDomainsInput(input: string): true | string {
  try {
    getEmailVerificationDomainsPayload(input);
    return true;
  } catch {
    return EMAIL_VERIFICATION_DOMAINS_ERROR;
  }
}

export function getEmailVerificationDomainsHelperText(isFocused: boolean, errorMessage?: string): string | undefined {
  return errorMessage ?? (isFocused ? EMAIL_VERIFICATION_DOMAINS_HELPER_TEXT : undefined);
}
